<template>
  <zj-layout-container v-if="activeCode == code">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :disabled="editable"
    >
      <el-checkbox-group
        @change="handleCheckedChange"
        v-model="Usersids"
        class="zj-user-list"
      >
        <el-checkbox
          v-for="item in UsersOptions"
          :key="item.id"
          :label="item.id"
          :value="item.id"
          >{{ item.userName }}</el-checkbox
        >
      </el-checkbox-group>
    </el-form>
  </zj-layout-container>
</template>
<script>
import { listUser } from "@/api/system/permission/user";
import utils from "@/utils";

export default {
  name: "ZjTreeItem",
  controller: "UI",
  action: "TreeItem",
  components: {},
  props: {
    code: { type: String },
    activeCode: { type: String, default: "" },
  },
  data() {
    return {
      UsersOptions: [],
      Usersids: [],
      CheckedUserItems: [],
    };
  },
  created: function () {
    this.getData();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    getData() {
      listUser({
        pageNum: 1,
        pageSize: 999,

        status: 0,

        deptId: this.code,
      }).then((res) => {
        if (res.code == 0) {
          this.UsersOptions = res.rows;
        } else {
          this.errmsg(res.msg);
        }
      });
    },
    handleCheckedChange(ids) {
      let { code } = this;
      this.Usersids = ids;
      utils.bus.$emit("getIds", { code, ids });
    },
  },
};
</script>